import React, { useReducer, ChangeEvent, useState,useEffect } from "react";
import { TabContainer } from "../SocialCaseTbas/Social.styled";
import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import General from "../../stores/GeneralStore";
import { Document } from "../Temporary Components/SocialCaseModal.styled";
import MoveInOut from "../../stores/MoveInOutStore";
import CONSTANTS, { EMPTY_GUID, PASSWORD_VALIDATION_MESSAGES } from "../../utils/constants";
import { init } from "@sentry/browser";
import User from "../../stores/UserStore";
import nocsRequestsStore from "../../stores/NocsRequestsStore";
import trashIcon from "../../assets/Delete.svg";
import { NotifyError } from "../../utils/ShowError";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import { NotifySuccess } from "../../utils/ShowSuccess";



interface Obj {
  [key: string]: any;
}

interface OptionalFile {
  id: string;
  name: string;
}

interface FileUpload {
  mediaType: string;
  fileName: string;
  buffer: string;
}

interface UpdateModalProps {
  open: boolean;
  onClose: () => void;
  initialData?: Obj;
  caseId?: any;
  caseReasons?: any;
  onSuccess?: () => void;
}

interface FormState {
  name: string;
  email: string;
  mobileNumber: string;
  sewerageNumber: string;
  premiseDetails: string;
  propertyUsage: string;
  vatRegistrationNumber: string;
  nationality: string;
  gender: string;
  dateOfBirth: string;
  // language: string;
  // poBox: string;
  emirate: string;
  // secondaryEmail: string;
  preferredServiceChannel: string;
  preferredPaymentChannel: string;
  tenancyContract: string;
  tocMorning: boolean;
  tocAfternoon: boolean;
  tocEvening: boolean;
  loader: boolean;
  loaderIndex: any;
  tenantContractFile: File | null;
  emiratesIDFile: File | null;
  optionalUploadedFiles: OptionalFile[];
  uploadingField: string | null;
  uploadedFiles: { [key: string]: FileUpload };
  fileErrors: { [key: string]: boolean };
  validationErrors: { [key: string]: string };
}

type FormAction = 
  | { type: 'UPDATE_FIELD'; field: string; value: string | string[] | File | null | boolean }
  | { type: 'SET_LOADER'; value: boolean }
  | { type: 'SET_LOADER_INDEX'; value: any }
  | { type: 'SET_UPLOADING_FIELD'; field: string | null }
  | { type: 'UPDATE_UPLOADED_FILES'; key: string; file: FileUpload }
  | { type: 'UPDATE_FILE_ERRORS'; key: string; error: boolean }
  | { type: 'SET_VALIDATION_ERRORS'; errors: { [key: string]: string } }
  | { type: 'CLEAR_VALIDATION_ERROR'; field: string }
  | { type: 'ADD_OPTIONAL_FILE'; file: OptionalFile }
  | { type: 'REMOVE_OPTIONAL_FILE'; fileId: string }
  | { type: 'RESET_FORM'; initialData: Obj };

const initialFormState = (initialData: Obj = {}): FormState => ({
  name: initialData.tenantDetails?.customerNameEng || "",
  email: initialData.tenantDetails?.email || "",
  mobileNumber: initialData.tenantDetails?.mobile || "",
  sewerageNumber: initialData.premiseDetails?.premiseId || "",
  premiseDetails: initialData.premiseDetails?.buildingName || "",
  propertyUsage: initialData.premiseDetails?.propertyUsage || "",
  vatRegistrationNumber: "",
  nationality: initialData?.tenantDetails?.nationality || "",
  gender: initialData?.tenantDetails?.sex || "",
  dateOfBirth:initialData?.tenantDetails?.dateOfBirth || "",
  // language: "",
  // poBox: "",
  emirate: initialData?.tenantDetails?.emirate || "",
  // secondaryEmail: "",
  preferredServiceChannel:initialData?.tenantDetails?.serviceDeliveryChannel || "",
  preferredPaymentChannel: initialData?.tenantDetails?.paymentChannel || "",
  tenancyContract: initialData?.tenantDetails?.tenancyContractExpiry || "",
  tocMorning: initialData?.tenantDetails?.tocMorning === "Y" || false,
  tocAfternoon: initialData?.tenantDetails?.tocCommNoon === "Y" || false,
  tocEvening: initialData?.tenantDetails?.tocCommEvening === "Y" || false,
  loader: false,
  loaderIndex: null,
  tenantContractFile: null,
  emiratesIDFile: null,
  optionalUploadedFiles: [],
  uploadingField: null,
  uploadedFiles: {},
  fileErrors: {},
  validationErrors: {},
});

const formReducer = (state: FormState, action: FormAction): FormState => {
  switch (action.type) {
    case 'UPDATE_FIELD':
      return { ...state, [action.field]: action.value };
    case 'SET_LOADER':
      return { ...state, loader: action.value };
    case 'SET_LOADER_INDEX':
      return { ...state, loaderIndex: action.value };
    case 'SET_UPLOADING_FIELD':
      return { ...state, uploadingField: action.field };
    case 'UPDATE_UPLOADED_FILES':
      return { 
        ...state, 
        uploadedFiles: { ...state.uploadedFiles, [action.key]: action.file } 
      };
    case 'UPDATE_FILE_ERRORS':
      return { 
        ...state, 
        fileErrors: { ...state.fileErrors, [action.key]: action.error } 
      };
    case 'SET_VALIDATION_ERRORS':
      return { 
        ...state, 
        validationErrors: action.errors 
      };
    case 'CLEAR_VALIDATION_ERROR':
      const { [action.field]: removed, ...remainingErrors } = state.validationErrors;
      return { 
        ...state, 
        validationErrors: remainingErrors 
      };
    case 'ADD_OPTIONAL_FILE':
      return { 
        ...state, 
        optionalUploadedFiles: [...state.optionalUploadedFiles, action.file] 
      };
    case 'REMOVE_OPTIONAL_FILE':
      return {
        ...state,
        optionalUploadedFiles: state.optionalUploadedFiles.filter(file => file.id !== action.fileId)
      };
    case 'RESET_FORM':
      return initialFormState(action.initialData);
    default:
      return state;
  }
};
const documentTypes: Obj = {
  passport: "Passport",
  emiratesid: "Emirates ID",
  familybook: "Family Book",
  salary: "Salary or Retirement Certificate",
  titledeed: "Title Deed",
  bankstatement: "Bank Statement (last 3 months)",
  dedcertificate: "Property Certificate from Land Dept.",
  municipalitycertificate: "Property Certificate from Ajman Municipality",
};


const UpdateModal: React.FC<UpdateModalProps> = ({
  open,
  onClose,
  initialData = {},
  caseId,
  caseReasons = {},
  onSuccess
}) => {
  
  // Check if fields should be editable based on case status
  const isEditable = initialData?.caseStatus === "HOLD-CUSTACT" ;
  const isMovein = initialData?.moveInMode;
  // const showFields = isEditable && isMovein !== "OTHERS";
    const showFields = false;
  //imitially showFields was designed to show show based on movinMode but as per new requirement the form should show only premise and tenancy so temporarily setting to false

  const [state, dispatch] = useReducer(formReducer, initialFormState(initialData));
  const currentLanguage = localStorage.getItem("settingUplanguage") ?? "en-US";
  const [submitloader,setSubmitLoader] = useState(false);
  const [existingFiles, setExistingFiles] = useState(initialData?.files || []);
  
  // Check if any case reason requires document upload
  const [hasDocumentRequirement, setHasDocumentRequirement] = useState(false);
  
  // Update document requirement state when caseReasons change
  useEffect(() => {
    if (caseReasons && Array.isArray(caseReasons) && caseReasons.length > 0) {
      const requiresDocument = caseReasons.some((reason: any) => reason.isDocument === true);
      setHasDocumentRequirement(requiresDocument);
    } else {
      setHasDocumentRequirement(false);
    }
  }, [caseReasons]);
  const getMainText = (fileName: any) => {
      const lowerFileName = fileName.toLowerCase();
  
      if (lowerFileName.includes("tenancy")) {
        return General?.codeLabels["cm_copy_tenancy"]?.label ?? "Copy of Tenant Contract";
      } else if (lowerFileName.includes("emirates")) {
        return General?.codeLabels["cm_uni"]?.label ?? "Emirates ID";
      } else {
        return General?.codeLabels['cm_doc']?.label ?? "Document";
      }
    }
    const handleDownloadCase = async (fileName: any, index: any) => {
  
    const data = {
      caseId: caseId,
      documentName: fileName,
      // tenantPersonId: User.info.personId
    }
  await nocsRequestsStore?.downloadMoveinDocument({ errorId: "download", data });
  }

  const handleDeleteDocument = async (fileName: any, index: any) => {
    // if (!window.confirm(General?.codeLabels["cm_confirm_delete"]?.label || "Are you sure you want to delete this document?")) {
    //   return;
    // }

    dispatch({ type: 'SET_LOADER', value: true });
    dispatch({ type: 'SET_LOADER_INDEX', value: index });

    try {
      const data = {
        documentName: fileName,
        caseId: caseId,
        // tenantPersonId: User.info.personId
      }
      
      const result = await nocsRequestsStore?.deleteMoveinDocument({ errorId: "delete", data });
      
      if (result?.message) {
        // Remove the file from the existing files state to update the UI
        setExistingFiles((prevFiles: any[]) => prevFiles.filter((file: any, fileIndex: number) => fileIndex !== index));
        NotifySuccess(General?.codeLabels[result?.message]?.label || "Document deleted successfully");
        
        // Force component re-render by updating the initialData
        if (initialData?.files) {
          initialData.files = initialData.files.filter((file: any, fileIndex: number) => fileIndex !== index);
        }
      }
    } catch (error) {
      NotifyError(General?.codeLabels["cm_delete_error"]?.label || "Failed to delete document");
    } finally {
      dispatch({ type: 'SET_LOADER', value: false });
      dispatch({ type: 'SET_LOADER_INDEX', value: null });
    }
  }

 

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    dispatch({ type: 'UPDATE_FIELD', field: e.target.name, value: e.target.value });
    // Clear validation error when user starts typing
    if (state.validationErrors[e.target.name]) {
      dispatch({ type: 'CLEAR_VALIDATION_ERROR', field: e.target.name });
    }
  };

  const validateForm = (): boolean => {
    const errors: { [key: string]: string } = {};
    if(showFields){

   

    // Required field validations
    if (!state.name.trim()) {
      errors.name = General?.codeLabels["cm_name_mand"]?.label || "Name is required";
    }

    if (!state.email.trim()) {
      errors.email = General?.codeLabels["cm_email_required"]?.label || "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)) {
      errors.email = General?.codeLabels["cm_email_invalid"]?.label || "Please enter a valid email address";
    }

    if (!state.mobileNumber.trim()) {
      errors.mobileNumber = General?.codeLabels["cm_mobilenumberreqerr"]?.label || "Mobile number is required";
    } else if (!/^\d{10,15}$/.test(state.mobileNumber.replace(/\s/g, ''))) {
      errors.mobileNumber = General?.codeLabels["cm_ivalid_mobile"]?.label || "Please enter a valid mobile number";
    }

    
    // if (!state.premiseDetails.trim()) {
    //   errors.premiseDetails = General?.codeLabels["cm_property_required"]?.label || "Property details are required";
    // }

    // if (!state.propertyUsage.trim()) {
    //   errors.propertyUsage = General?.codeLabels["cm_property_usage_required"]?.label || "Property usage is required";
    // }

    if (!state.nationality.trim()) {
      errors.nationality = General?.codeLabels["cm_naterr"]?.label || "Nationality is required";
    }

    if (!state.gender.trim()) {
      errors.gender = General?.codeLabels["cm_mob_gendrerr"]?.label || "Gender is required";
    }

    if (!state.dateOfBirth.trim()) {
      errors.dateOfBirth = General?.codeLabels["cm_mob_doberr"]?.label || "Date of birth is required";
    }

    if (!state.emirate.trim()) {
      errors.emirate = General?.codeLabels["cm_select_emirates"]?.label || "Emirate is required";
    }

    if (!state.preferredServiceChannel.trim()) {
      errors.preferredServiceChannel = General?.codeLabels["cm_prefferes_validation"]?.label || "Preferred service channel is required";
    }

    if (!state.preferredPaymentChannel.trim()) {
      errors.preferredPaymentChannel = General?.codeLabels["cm_preffered_payment_validation"]?.label || "Preferred payment channel is required";
    }

    

    // At least one time of communication should be selected
    if (!state.tocMorning && !state.tocAfternoon && !state.tocEvening) {
      errors.preferredTimeOfCommunication = General?.codeLabels["cm_time_communication_required"]?.label || "Please select at least one preferred time of communication";
    }
 }
 if (!state.sewerageNumber.trim()) {
      errors.sewerageNumber = General?.codeLabels["cm_sewerage_required"]?.label || "Sewerage number is required";
    }

 if (!state.tenancyContract.trim()) {
      errors.tenancyContract = General?.codeLabels["cm_tenancy_contract_required"]?.label || "Tenancy contract date is required";
    }

    // Document validations - only validate if document requirement exists
    if (hasDocumentRequirement) {
      if (!state.uploadedFiles["tenantContractFile"]) {
        errors.tenantContractFile = General?.codeLabels["cm_tenant_contract_required"]?.label || "Tenant contract document is required";
      }

      if (!state.uploadedFiles["emiratesIDFile"]) {
        errors.emiratesIDFile = General?.codeLabels["cm_emirates_id_required"]?.label || "Emirates ID document is required";
      }
    }

    dispatch({ type: 'SET_VALIDATION_ERRORS', errors });
    return Object.keys(errors).length === 0;
  };

  const handleUploadFileChange = async (
    event: ChangeEvent<HTMLInputElement>,
    inputName: string
  ) => {
    const files: FileList | null = event.target.files;
    const fileUploadPromises: Promise<any>[] = [];

    // Function to get file suffix based on input name
    const getFileSuffix = (inputName: string): string => {
      switch (inputName) {
        case "tenantContractFile":
          return  General?.codeLabels["cm_copy_tenancy"]?.label ?? "Copy of Tenant Contract";
        case "emiratesIDFile":
          return General?.codeLabels["cm_uni"]?.label ?? "Emirates ID";
        default:
          return General?.codeLabels["cm_doc"]?.label ?? "Document";
      }
    };

    if (files) {
      for (let i = 0; i < files.length; i++) {
        const file: File = files[i];

        // Check if the file is a PDF
        if (file.type === "application/pdf") {
          const promise = new Promise<any>((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
              const buffer = reader.result?.slice(28) as string;
              const originalFileName = file.name;
              const fileExtension = originalFileName.substring(originalFileName.lastIndexOf('.'));
              const fileNameWithoutExtension = originalFileName.substring(0, originalFileName.lastIndexOf('.'));
              const suffix = getFileSuffix(inputName);
              const fileName = fileNameWithoutExtension + suffix + fileExtension;
              const mediaType = file.type;

              const fileUpload: FileUpload = { mediaType, fileName, buffer };
              resolve({file:fileUpload, key: inputName});
            };
          });

          fileUploadPromises.push(promise);
        } else {
          NotifyError(
            General?.codeLabels["cm_complaint_error"]?.label !== undefined
              ? General?.codeLabels["cm_complaint_error"]?.label
              : "Only PDF files are allowed"
          );
        }
      }
    

      Promise.all(fileUploadPromises)
        .then((file) => {
          // Update uploaded files
          dispatch({ 
            type: 'UPDATE_UPLOADED_FILES', 
            key: file[0]?.key, 
            file: file[0]?.file 
          });

          // Clear file errors for mandatory documents
          if (file[0]?.key === "tenantContractFile" || file[0]?.key === "emiratesIDFile") {
            dispatch({ 
              type: 'UPDATE_FILE_ERRORS', 
              key: file[0]?.key, 
              error: false 
            });
            // Clear validation error when file is uploaded
            dispatch({ 
              type: 'CLEAR_VALIDATION_ERROR', 
              field: file[0]?.key 
            });
          }
        })
        .catch((error) => {
          console.error("Error while processing file uploads:", error);
          NotifyError(General?.codeLabels["cm_complaint_error"]?.label);
        });
    }
  };

  const handleAddOptionalDocument = () => {
    const newFile: OptionalFile = {
      id: Date.now().toString(),
      name: `optional_document_${state.optionalUploadedFiles.length + 1}`
    };
    dispatch({ type: 'ADD_OPTIONAL_FILE', file: newFile });
  };

  const handleRemoveOptionalDocument = (fileId: string) => {
    dispatch({ type: 'REMOVE_OPTIONAL_FILE', fileId });
  };

  const handleSubmit = async () => {
    // Validate form before submission - only if showFields is true
    setSubmitLoader(true);
    if (!validateForm()) {
      NotifyError(
        General?.codeLabels["cm_validation_error"]?.label || "Please fill all required fields correctly."
      );
      setSubmitLoader(false);
      return;
    }
    
    // Prepare the payload with form data
    const payload={
      caseId:caseId,
      caseAction:"1",
      loginId:"",
      registrationDate:"",
      // personId:User?.profile?.personId,
      cisDivision:"",
      sex:state?.gender,
      dateOfBirth:state?.dateOfBirth,
      nationality:state?.nationality,
      emirate:state?.emirate,
      customerNameEng:state?.name,
      customerNameAra:state?.name,
      tenancyContractNumber:initialData?.tenantDetails?.tenancyContractNumber || "",
      tenancyContractExpiry:state?.tenancyContract || "",
      mobile:state?.mobileNumber,
      email:state?.email,
      landline:"",
      trnOrVatNumber:initialData?.tenantDetails?.trnOrVatNumber || "",
      serviceDeliveryChannel:state?.preferredServiceChannel || "",
      paymentChannel:state?.preferredPaymentChannel || "",
      tocMorning: state?.tocMorning ? "Y" : "N",
      tocCommNoon: state?.tocAfternoon ? "Y" : "N",
      tocCommEvening: state?.tocEvening ? "Y" : "N",
      caseComments:"",
      holdReasons:initialData?.holdReasons,
      rejectionReasons:initialData?.rejectionReasons,
      // Include uploaded files
      // uploadedDocuments: state.uploadedFiles,
    }

   
    
    let uploadRes = null;
    let res = null;
    
    // Only upload documents if document requirement exists
    if (hasDocumentRequirement) {
      const uploadFiles = Object.values(state.uploadedFiles);
      const documentPayload={
        data:{
          caseId: caseId,
          customerMessage:"",
          action:"1",
          uploadType: "AjmanKnowsYou",
          uploadScreen: User?.info?.personId ? 'mwl' : 'mwol'
        },
        multiFileUpload: uploadFiles,
        isFileTypeValid: true,
        isFileUploadValid: true,
      }
      uploadRes = await nocsRequestsStore?.uploadDocumentsForMoveinRequestUpdation({
        errorId: "uploadMoveInRequestUpdationDocuments",
        data: documentPayload,
      });
      if (uploadRes) {
         res = await nocsRequestsStore?.getMoveinRequestUpdation({
         errorId: "getMoveInRequestUpdation",
         data: payload,
        });
      }
      
    }
    else{
       res = await nocsRequestsStore?.getMoveinRequestUpdation({
         errorId: "getMoveInRequestUpdation",
         data: payload,
        });
    }
    if (res && (uploadRes || !hasDocumentRequirement)) {
    
      NotifySuccess(General?.codeLabels[uploadRes?.message]?.label || "Details updated successfully");
      NotifySuccess(res || "Details updated successfully");

      setSubmitLoader(false);
      onClose();
      onSuccess?.();
    }
    onClose();
  };

  if (!open) return null;

  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  return (
    <div
      style={{
        zIndex: 9999,
        backgroundColor: contrast?.contrastBackground || "#fff",
        overflow: "auto",
        height: "90%",
        width: General?.isLargeScreen ? "80%" : "100%",
        margin: "auto",
        direction:
          General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode === "ARA"
            ? "rtl"
            : "ltr",
        position: "fixed",
        top: "5%",
        left: "0",
        right: "0",
        boxShadow: "0 2px 16px rgba(0,0,0,0.2)",
        borderRadius: 8,
      }}
    >
      <div
        style={{
          backgroundColor: contrast?.contrastBackground || "#101e8e",
          padding: "20px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        className={General?.colorClass}
      >
        <h1 style={{ color: "white", margin: 0 }}>
          {General?.codeLabels["cm_update_details"]?.label || "Update Details"}
        </h1>
        <span
          style={{ color: "white", fontSize: 32, cursor: "pointer" }}
          onClick={onClose}
        >
          x
        </span>
      </div>
      <TabContainer
        style={{
          padding: "25px",
          display: General?.isLargeScreen ? "grid" : "flex",
          flexDirection: General?.isLargeScreen ? "row" : "column",
        }}
      >
        {/* Case Reasons Display */}
        {caseReasons && Array?.isArray(caseReasons) && caseReasons?.length > 0 && (
          <div style={{ gridColumn: "1 / -1", marginBottom: "20px" }}>
            <div
              style={{
                padding: "15px",
                backgroundColor: "#FFF4E5",
                border: "1px solid #FF9800",
                borderRadius: "4px",
                borderLeft: "4px solid #FF9800"
              }}
            >
              <h3
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: "#E65100",
                  margin: "0 0 8px 0",
                  fontWeight: 600,
                }}
                className={General?.textClass}
              >
                {(initialData?.caseStatus === "HOLD-CUSTACT"|| initialData?.caseStatus === "HOLD-FLDINSP") ? General?.codeLabels["cm_hold_reasons"]?.label : General?.codeLabels["cm_rejection_reasons"]?.label}
              </h3>
              <div>
                {caseReasons.filter((reason: any) =>
                initialData?.caseStatus === "HOLD-CUSTACT" || initialData?.caseStatus === "HOLD-FLDINSP"
                  ? (reason.type === 1 || reason.type === 0)
                  : initialData?.caseStatus === "REJECTED"
                  ? reason.type === 2
                  : false
                  ).map((reason: any, index: number) => (
                  <p
                    key={reason.id || index}
                    style={{
                      fontSize: `${General.accessibility.fontSize - 0.1}rem`,
                      color: "#E65100",
                      margin: index === 0 ? "0" : "8px 0 0 0",
                      lineHeight: "1.4"
                    }}
                    className={General?.textClass}
                  >
                    • {reason?.description}
                  </p>
                ))}
              </div>
            </div>
          </div>
        )}

        {showFields ? (
          <>
            <div style={{ gridColumn: "1 / -1", marginBottom: "20px" }}>
              <h2
                style={{
                  fontSize: `${General.accessibility.fontSize + 0.2}rem`,
                  color: "rgba(16, 30, 142, 1)",
                  margin: 0,
                  fontWeight: 600,
                }}
                className={General?.textClass}
              >
               {General?.codeLabels["cm_registration_user_information"]?.label !==
              undefined
                ? General?.codeLabels["cm_registration_user_information"]?.label
                : "User Information"}
              </h2>
            </div>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_dname"]?.label !== undefined
                    ? General?.codeLabels["cm_dname"]?.label
                    : "Name "}
          <input
            name="name"
            type="text"
            value={state.name}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.name ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
          {state.validationErrors.name && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.name}
            </div>
          )}
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_primaryemail"]?.label !== undefined
                    ? General?.codeLabels["cm_primaryemail"]?.label
                    : "Primary Email Address"}
          <input
            name="email"
            type="email"
            value={state.email}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.email ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
          {state.validationErrors.email && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.email}
            </div>
          )}
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_mobilenumber"]?.label !== undefined
                    ? General?.codeLabels["cm_mobilenumber"]?.label
                    : "Mobile Number*(05X-Xxx-Xxxx)"}
          <input
            name="mobileNumber"
            type="text"
            value={state.mobileNumber}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.mobileNumber ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
          {state.validationErrors.mobileNumber && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.mobileNumber}
            </div>
          )}
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_premiseid"]?.label !== undefined
                    ? General?.codeLabels["cm_premiseid"]?.label
                    : "Sewerage Number"}
          <input
            name="sewerageNumber"
            type="text"
            value={state.sewerageNumber}
            onChange={handleChange}
            readOnly={true}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.sewerageNumber ? "red" : undefined,
              opacity:  0.6 ,
              cursor: "not-allowed"
            }}
          />
          {state.validationErrors.sewerageNumber && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.sewerageNumber}
            </div>
          )}
        </Label>
        {/* <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_propertydet"]?.label !== undefined
            ? General?.codeLabels["cm_propertydet"]?.label
            : "Property Details"}{" "}
          <input
            name="premiseDetails"
            type="text"
            value={state.premiseDetails}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.premiseDetails ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
          {state.validationErrors.premiseDetails && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.premiseDetails}
            </div>
          )}
        </Label> */}
        {/* <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_propertyusage"]?.label !== undefined
                    ? General?.codeLabels["cm_propertyusage"]?.label
                    : "Property Usage"}
          <input
            name="propertyUsage"
            type="text"
            value={state.propertyUsage || ""}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.propertyUsage ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
          {state.validationErrors.propertyUsage && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.propertyUsage}
            </div>
          )}
        </Label> */}
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_registration_vat_register"]
                    ?.label !== undefined
                    ? General?.codeLabels["cm_registration_vat_register"]?.label
                    : "VAT Registration Number (TRN)"}
          <input
            name="vatRegistrationNumber"
            type="text"
            value={state.vatRegistrationNumber || ""}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
     </Label>
      <div style={{ gridColumn: "1 / -1", marginBottom: "20px" }}>
          <h2
            style={{
              fontSize: `${General.accessibility.fontSize + 0.2}rem`,
              color: "rgba(16, 30, 142, 1)",
              margin: 0,
              fontWeight: 600,
            }}
            className={General?.textClass}
          >
           {General?.codeLabels["cm_personal_information"]?.label}
          </h2>
        </div>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_nationality"]?.label !== undefined
                    ? General?.codeLabels["cm_nationality"]?.label
                    : "Nationality"}
          <select
            name="nationality"
            value={state.nationality}
            onChange={handleChange}
            disabled={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.nationality ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "pointer"
            }}
          >
            <option value="">Select</option>
             {General?.codeLabels["cm_pdc_paymentaccounts"]
                      ?.languageCode == "ARA"
                      ? CONSTANTS.countriesAr.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                General?.otpUserData?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })
                      : General?.codeLabels["cm_pdc_paymentaccounts"]
                          ?.languageCode == "HIN"
                      ? CONSTANTS.countriesHi.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              selected={
                                General?.otpUserData?.nationality?.key ==
                                nationality?.key
                                  ? true
                                  : false
                              }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })
                      : CONSTANTS.countriesEn.map((nationality) => {
                          return (
                            <option
                              value={nationality?.key}
                              // selected={
                              //   General?.otpUserData?.nationality?.key ==
                              //   nationality?.key
                              //     ? true
                              //     : false
                              // }
                            >
                              {nationality?.value}
                            </option>
                          );
                        })}
          </select>
          {state.validationErrors.nationality && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.nationality}
            </div>
          )}
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_gender"]?.label !== undefined
                    ? General?.codeLabels["cm_gender"]?.label
                    : "Gender"}
          <select
            name="gender"
            value={state.gender}
            onChange={handleChange}
            disabled={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.gender ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "pointer"
            }}
          >
            <option value="">Select</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
          {state.validationErrors.gender && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.gender}
            </div>
          )}
        </Label>
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_dob"]?.label !== undefined
                    ? General?.codeLabels["cm_dob"]?.label
                    : "Date Of Birth"}
          <input
            name="dateOfBirth"
            type="date"
            value={state.dateOfBirth}
            onChange={handleChange}
            readOnly={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.dateOfBirth ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "text"
            }}
          />
          {state.validationErrors.dateOfBirth && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.dateOfBirth}
            </div>
          )}
        </Label>
        {/* <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_choose_lang"]?.label || "Language"}
          <select
            name="language"
            value={state.language}
            onChange={handleChange}
            style={{ background: "white" }}
          >
            <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.language?.key == "ENG"
                          ? true
                          : false
                      }
                      value="ENG-English"
                    >
                      {General?.codeLabels["cm_eng"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.language?.key == "HIN"
                          ? true
                          : false
                      }
                      value="HIN-Hindi"
                    >
                      {General?.codeLabels["cm_hin"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.language?.key == "ARA"
                          ? true
                          : false
                      }
                      value="ARA-Arabic"
                    >
                      {General?.codeLabels["cm_ar"]?.label}
                    </option>
          </select>
        </Label> */}
        {/* <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_man_pobox"]?.label || "PO Box"}
          <input
            name="poBox"
            type="text"
            value={state.poBox}
            onChange={handleChange}
            style={{ background: "white" }}
          />
        </Label> */}
        <Label
          className={General?.textClass}
          style={{
            fontSize: `${General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
        >
          {General?.codeLabels["cm_emirate"]?.label
                    ? General?.codeLabels["cm_emirate"]?.label
                    : "Emirate"}
          <select
            name="emirate"
            value={state.emirate}
            onChange={handleChange}
            disabled={!isEditable}
            style={{ 
              background: "white",
              borderColor: state.validationErrors.emirate ? "red" : undefined,
              opacity: !isEditable ? 0.6 : 1,
              cursor: !isEditable ? "not-allowed" : "pointer"
            }}
          >
           <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "ABU DH" ? true : false
                      }
                      value="ABU DH"
                    >
                      {General?.codeLabels["cm_abudhabi"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "AJMAN" ? true : false
                      }
                      value="AJMAN"
                    >
                      {General?.codeLabels["cm_ajman"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "DUBAI" ? true : false
                      }
                      value="DUBAI"
                    >
                      {General?.codeLabels["cm_dubai"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "FUJAIR" ? true : false
                      }
                      value="FUJAIR"
                    >
                      {General?.codeLabels["cm_fujairah"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "RAS AL" ? true : false
                      }
                      value="RAS AL"
                    >
                      {General?.codeLabels["cm_rasalkhaimah"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "SHARJA" ? true : false
                      }
                      value="SHARJA"
                    >
                      {General?.codeLabels["cm_sharjah"]?.label}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.state == "UMM AL" ? true : false
                      }
                      value="UMM AL"
                    >
                      {General?.codeLabels["cm_ummalquwain"]?.label}
                    </option>
          </select>
          {state.validationErrors.emirate && (
            <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
              {state.validationErrors.emirate}
            </div>
          )}
       </Label>
      {/* <Label
        className={General?.textClass}
        style={{
          fontSize: `${General.accessibility.fontSize}rem`,
          color: "rgba(16, 30, 142, 1)",
        }}
      >
        {General?.codeLabels["cm_secondary_email"]?.label || "Secondary Email Address"}
        <input
          name="secondaryEmail"
          type="email"
          value={state.secondaryEmail || ""}
          onChange={handleChange}
          style={{ background: "white" }}
        />
      </Label> */}
      <Label
        className={General?.textClass}
        style={{
          fontSize: `${General.accessibility.fontSize}rem`,
          color: "rgba(16, 30, 142, 1)",
        }}
      >
        {General?.codeLabels["cm_preffered_delivery_channel"]
                    ?.label !== undefined
                    ? General?.codeLabels["cm_preffered_delivery_channel"]
                        ?.label
                    : "Preferred Service Delivery Channel*"}
        <select
          name="preferredServiceChannel"
          value={state.preferredServiceChannel || ""}
          onChange={handleChange}
          disabled={!isEditable}
          style={{ 
            background: "white",
            borderColor: state.validationErrors.preferredServiceChannel ? "red" : undefined,
            opacity: !isEditable ? 0.6 : 1,
            cursor: !isEditable ? "not-allowed" : "pointer"
          }}
        >
         <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>

                    <option value="ASW">
                      {General?.codeLabels["cm_website"]?.label !== undefined
                        ? General?.codeLabels["cm_website"]?.label
                        : "Ajman Sewerage website"}
                    </option>

                    <option value="ASMA">
                      {General?.codeLabels["cm_mobileapp"]?.label !== undefined
                        ? General?.codeLabels["cm_mobileapp"]?.label
                        : "Ajman Sewerage mobile App"}
                    </option>

                    <option value="ASCC">
                      {General?.codeLabels["cm_contactcen"]?.label !== undefined
                        ? General?.codeLabels["cm_contactcen"]?.label
                        : "Ajman Sewerage Contact Center"}
                    </option>
                    <option value="MAIL">
                      {General?.codeLabels["cm_email"]?.label !== undefined
                        ? General?.codeLabels["cm_email"]?.label
                        : "Email address "}
                    </option>
                    <option value="CHSC">
                      {General?.codeLabels["cm_payhsc"]?.label !== undefined
                      ? General?.codeLabels["cm_payhsc"]?.label
                      : "Customer Happiness Service Center"}
                    </option>
        </select>
        {state.validationErrors.preferredServiceChannel && (
          <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
            {state.validationErrors.preferredServiceChannel}
          </div>
        )}
      </Label>
      <Label
        className={General?.textClass}
        style={{
          fontSize: `${General.accessibility.fontSize}rem`,
          color: "rgba(16, 30, 142, 1)",
        }}
      >
         {General?.codeLabels["cm_preffered_payment_chanel"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_payment_chanel"]?.label
                    : "Preferred Payment Channel*"}
        <select
          name="preferredPaymentChannel"
          value={state.preferredPaymentChannel || ""}
          onChange={handleChange}
          disabled={!isEditable}
          style={{ 
            background: "white",
            borderColor: state.validationErrors.preferredPaymentChannel ? "red" : undefined,
            opacity: !isEditable ? 0.6 : 1,
            cursor: !isEditable ? "not-allowed" : "pointer"
          }}
        >
          <option value={""}>
                      {General?.codeLabels["cm_mob_select"]?.label !== undefined
                        ? General?.codeLabels["cm_mob_select"]?.label
                        : "Select"}
                    </option>
                    <option
                      // selected={
                      //   General?.otpUserData?.favouritePaymentChannel?.key ==
                      //   "PYK"
                      //     ? true
                      //     : false
                      // }
                      value="PYK"
                    >
                      {General?.codeLabels["cm_paykio"]?.label !== undefined
                        ? General?.codeLabels["cm_paykio"]?.label
                        : "Payment Kiosks"}
                    </option>
                    <option
                      // selected={
                      //   General?.otpUserData?.favouritePaymentChannel?.key ==
                      //   "AAE"
                      //     ? true
                      //     : false
                      // }
                      value="AAE"
                    >
                      {General?.codeLabels["cm_payansari"]?.label !== undefined
                        ? General?.codeLabels["cm_payansari"]?.label
                        : "Al Ansari Exchange"}
                    </option>
                    <option
                      // selected={
                      //   General?.otpUserData?.favouritePaymentChannel?.key ==
                      //   "UAEEX"
                      //     ? true
                      //     : false
                      // }
                      value="UAEEX"
                    >
                      {General?.codeLabels["cm_paysharjahislamicbank"]?.label !== undefined
                        ? General?.codeLabels["cm_paysharjahislamicbank"]?.label
                        : "Sharjah Islamic Bank"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "AJBNK"
                          ? true
                          : false
                      }
                      value="AJBNK"
                    >
                      {General?.codeLabels["cm_payajmanbank"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_payajmanbank"]?.label
                        : "Ajman Bank"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "DXBIB"
                          ? true
                          : false
                      }
                      value="DXBIB"
                    >
                      {General?.codeLabels["cm_paydib"]?.label !== undefined
                        ? General?.codeLabels["cm_paydib"]?.label
                        : "Dubai Islamic Bank"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "ENBD"
                          ? true
                          : false
                      }
                      value="ENBD"
                    >
                      {General?.codeLabels["cm_payendb"]?.label !== undefined
                        ? General?.codeLabels["cm_payendb"]?.label
                        : "Emirates NBD"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "CASH"
                          ? true
                          : false
                      }
                      value="CASH"
                    >
                      {General?.codeLabels["cm_paycash"]?.label !== undefined
                        ? General?.codeLabels["cm_paycash"]?.label
                        : "Cash Deposit"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "CHQ"
                          ? true
                          : false
                      }
                      value="CHQ"
                    >
                      {General?.codeLabels["cm_paycheque"]?.label !== undefined
                        ? General?.codeLabels["cm_paycheque"]?.label
                        : "Cheque Deposit"}
                    </option>
                    <option
                      selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "ONLN"
                          ? true
                          : false
                      }
                      value="ONLN"
                    >
                      {General?.codeLabels["cm_payonline"]?.label !== undefined
                        ? General?.codeLabels["cm_payonline"]?.label
                        : "Online"}
                    </option>
                    <option selected={
                        General?.otpUserData?.favouritePaymentChannel?.key ==
                        "CHSC"
                          ? true
                          : false
                      }
                      value="CHSC">
                     {General?.codeLabels["cm_payhsc"]?.label !== undefined
                      ? General?.codeLabels["cm_payhsc"]?.label
                      : "Customer Happiness Service Center"}
                    </option>
        </select>
        {state.validationErrors.preferredPaymentChannel && (
          <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
            {state.validationErrors.preferredPaymentChannel}
          </div>
        )}
      </Label>
      <Label
        className={General?.textClass}
        style={{
          fontSize: `${General.accessibility.fontSize}rem`,
          color: "rgba(16, 30, 142, 1)",
        }}
      >
        {General?.codeLabels["cm_tced"]?.label || "Tenancy Contract Expiry Date"}
        <input
          name="tenancyContract"
          type="date"
          min={new Date().toISOString().split("T")[0]}
          value={state.tenancyContract || ""}
          onChange={handleChange}
          readOnly={!isEditable}
          style={{ 
            background: "white",
            borderColor: state.validationErrors.tenancyContract ? "red" : undefined,
            opacity: !isEditable ? 0.6 : 1,
            cursor: !isEditable ? "not-allowed" : "text"
          }}
        />
        {state.validationErrors.tenancyContract && (
          <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
            {state.validationErrors.tenancyContract}
          </div>
        )}
      </Label>
      <Label
        className={General?.textClass}
        style={{
          fontSize: `${General.accessibility.fontSize}rem`,
          color: "rgba(16, 30, 142, 1)",
          marginTop: "20px",
        }}
      >
        {General?.codeLabels["cm_preffered_communication"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_preffered_communication"]?.label
                    : "Preferred Time of Communication*"}
        <div style={{ display: "flex", gap: "20px", marginTop: "8px" }}>
          {[
            {
              key: "morning",
              stateKey: "tocMorning",
              label:
                General?.codeLabels["cm_morning"]?.label !== undefined
                  ? General?.codeLabels["cm_morning"]?.label
                  : "Morning",
            },
            {
              key: "afternoon",
              stateKey: "tocAfternoon",
              label:
                General?.codeLabels["cm_afternoon"]?.label !== undefined
                  ? General?.codeLabels["cm_afternoon"]?.label
                  : "Afternoon",
            },
            {
              key: "evening",
              stateKey: "tocEvening",
              label:
                General?.codeLabels["cm_evening"]?.label !== undefined
                  ? General?.codeLabels["cm_evening"]?.label
                  : "Evening",
            },
          ].map((time) => (
            <label key={time.key} style={{ display: "flex", alignItems: "center", cursor: !isEditable ? "not-allowed" : "pointer", opacity: !isEditable ? 0.6 : 1 }}>
              <input
                type="checkbox"
                name={time.stateKey}
                value={time.key}
                checked={state[time.stateKey as keyof FormState] as boolean}
                onChange={(e) => {
                  const checked = e.target.checked;
                  dispatch({ type: 'UPDATE_FIELD', field: time.stateKey, value: checked });
                }}
                disabled={!isEditable}
                style={{
                  accentColor: "#62AA51",
                  background: contrast?.contrastColor ? contrast?.contrastColor : "",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : General?.ColorAss,
                  width: "15px",
                }}
              />
              <span style={{ fontWeight: 500, fontSize: "1rem" }}>
                {time.label}
              </span>
            </label>
          ))}
        </div>
        {state.validationErrors.preferredTimeOfCommunication && (
          <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
            {state.validationErrors.preferredTimeOfCommunication}
          </div>
        )}
      </Label>
          </>
        ) : (
          <div
            style={{
              gridColumn: "1 / -1",
              padding: "20px 2px",
              display: "flex",
              gap: "20px",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "flex-start",
            }}
          >
            <div style={{ flex: "1 1 300px", minWidth: 220 }}>
              <Label
                className={General?.textClass}
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: "rgba(16, 30, 142, 1)",
                }}
              >
                {General?.codeLabels["cm_premiseid"]?.label !== undefined
                  ? General?.codeLabels["cm_premiseid"]?.label
                  : "Sewerage Number"}
                <input
                  name="sewerageNumber"
                  type="text"
                  value={state.sewerageNumber}
                  onChange={handleChange}
                  readOnly={true}
                  style={{
                    background: "white",
                    borderColor: state.validationErrors.sewerageNumber ? "red" : undefined,
                    opacity: 0.6,
                    cursor: "not-allowed",
                  }}
                />
                {state.validationErrors.sewerageNumber && (
                  <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                    {state.validationErrors.sewerageNumber}
                  </div>
                )}
              </Label>
            </div>

            <div style={{ flex: "1 1 300px", minWidth: 220 }}>
              <Label
                className={General?.textClass}
                style={{
                  fontSize: `${General.accessibility.fontSize}rem`,
                  color: "rgba(16, 30, 142, 1)",
                }}
              >
                {General?.codeLabels["cm_tced"]?.label || "Tenancy Contract Expiry Date"}
                <input
                  name="tenancyContract"
                  type="date"
                  min={new Date().toISOString().split("T")[0]}
                  value={state.tenancyContract || ""}
                  onChange={handleChange}
                  readOnly={!isEditable}
                  style={{
                    background: "white",
                    borderColor: state.validationErrors.tenancyContract ? "red" : undefined,
                    opacity: !isEditable ? 0.6 : 1,
                    cursor: !isEditable ? "not-allowed" : "text",
                  }}
                />
                {state.validationErrors.tenancyContract && (
                  <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>
                    {state.validationErrors.tenancyContract}
                  </div>
                )}
              </Label>
            </div>
          </div>
        )}
    
      </TabContainer>
      {/* {showFields && ( */}
        <TabContainer>
      <div style={{ padding: "20px"}}>
         <h2
          style={{
            fontSize: `${1.5 * General.accessibility.fontSize}rem`,
            color: "rgba(16, 30, 142, 1)",
          }}
          className={General?.textClass}
        >
          {General?.codeLabels['cm_doc']?.label ? General?.codeLabels['cm_doc']?.label : "Documents"}
        </h2>
        
        {/* Document Upload Section - Only show when documents are required */}
        {isEditable && hasDocumentRequirement && (
          <>
         <Document
           exists={false}
           mainText={
             General?.codeLabels["cm_copy_tenancy"]?.label !==
             undefined
               ? General?.codeLabels["cm_copy_tenancy"]?.label
               : "Copy of Tenant Contract"
           }
           subText={
             General?.codeLabels["cm_mandatory_document"]
               ?.label !== undefined
               ? General?.codeLabels["cm_mandatory_document"]
                   ?.label
               : "Mandatory Document"
           }
           onChange={isEditable ? (e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFileChange(e, "tenantContractFile") } : undefined}
           inputName={"tenantContractFile"}
           name={state.uploadedFiles["tenantContractFile"]?.fileName || ""}
         />
         {state.validationErrors.tenantContractFile && (
           <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px", marginBottom: "10px" }}>
             {state.validationErrors.tenantContractFile}
           </div>
         )}
         
         <Document
           exists={false}
           mainText={
             General?.codeLabels["cm_emirate_id_doc"]?.label !==
             undefined
               ? General?.codeLabels["cm_emirate_id_doc"]?.label
               : "Copy of Emirates ID"
           }
           subText={
             General?.codeLabels["cm_mandatory_document"]
               ?.label !== undefined
               ? General?.codeLabels["cm_mandatory_document"]
                   ?.label
               : "Mandatory Document"
           }
           onChange={isEditable ? (e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFileChange(e, "emiratesIDFile") } : undefined}
           inputName={"emiratesIDFile"}
           name={state.uploadedFiles["emiratesIDFile"]?.fileName || ""}
         />
         {state.validationErrors.emiratesIDFile && (
           <div style={{ color: "red", fontSize: "0.8rem", marginTop: "4px", marginBottom: "10px" }}>
             {state.validationErrors.emiratesIDFile}
           </div>
         )}
         
         {/* <div
           style={{
             border: `1px solid ${contrast?.contrastBackground
               ? contrast?.contrastBackground
               : ""}`,
             textAlign: "center",
             cursor: isEditable ? "pointer" : "not-allowed",
             display: "inline-block",
             height: "25px",
             fontFamily: "Segoe UI",
             fontStyle: "normal",
             fontWeight: "700",
             fontSize: "14px",
             lineHeight: "20px",
             textTransform: "uppercase",
             background: contrast?.contrastColor
               ? contrast?.contrastColor
               : "",
             color: contrast?.contrastBackground
               ? contrast?.contrastBackground
               : "",
             width: General?.isLargeScreen ? "210px" : "100%",
             opacity: !isEditable ? 0.6 : 1
           }}
           onClick={isEditable ? handleAddOptionalDocument : undefined}
         >
           {General?.codeLabels["cm_add_attachment"]?.label !==
           undefined
             ? General?.codeLabels["cm_add_attachment"]?.label
             : "Add Document"}
         </div>
        
         {state.optionalUploadedFiles.map((optionalFile: OptionalFile) => (
           <div key={optionalFile.id} style={{ display: "flex", alignItems: "center" }}>
             <div
               style={{
                 width: General?.isLargeScreen ? "50%" : "90%",
               }}
             >
               <Document
                 exists={!!state.uploadedFiles[optionalFile.name]}
                 mainText={optionalFile.name}
                 subText={
                   General?.codeLabels["cm_optional_document"]
                     ?.label !== undefined
                     ? General?.codeLabels["cm_optional_document"]
                         ?.label
                     : "Optional Document"
                 }
                 onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleUploadFileChange(e, optionalFile.name) }}
                 inputName={optionalFile.name}
                 name={state.uploadedFiles[optionalFile.name]?.fileName || ""}
               />
             </div>
             <div style={{ marginRight: "1rem" }}>
               <button
                 type="button"
                 style={{
                   cursor: "pointer",
                   background: "none",
                   border: 0,
                 }}
                 onClick={() =>
                   handleRemoveOptionalDocument(optionalFile.id)
                 }
               >
                 <img
                   src={trashIcon}
                   alt="Remove Optional Attachment"
                 />
               </button>
             </div>
           </div>
         ))} */}
          </>
        )}
         
        {/* Existing Files Section */}
        {existingFiles && existingFiles.length > 0 && (
          <div style={{ marginTop: "30px" }}>
            <h3
              style={{
                fontSize: `${1.2 * General.accessibility.fontSize}rem`,
                color: "rgba(16, 30, 142, 1)",
                marginBottom: "15px",
                fontWeight: "600"
              }}
              className={General?.textClass}
            >
              {General?.codeLabels['cm_existing_files']?.label || "Existing Files"}
            </h3>
            {existingFiles.map((file: any, index: number) => (
              <div key={index} style={{ display: "flex", alignItems: "center"}}>
                <div style={{ flex: 1 }}>
                  <Document
                    exists={true}
                    mainText={getMainText(file.fileName)}
                    subText={General?.codeLabels["cm_mandatory_document"]?.label || "Document"}
                    name={file.fileName}
                    size={file.fileSize}
                    inputName=""
                    downloadClick={handleDownloadCase}
                    index={index}
                    loader={state.loader}
                    loaderIndex={state.loaderIndex}
                  />
                </div>
                {isEditable && hasDocumentRequirement &&(
                  <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                    {state.loader && state.loaderIndex === index ? (
                      <Spinner width="20px" height="20px" />
                    ) : (
                      <img
                        src={trashIcon}
                        alt="Delete Document"
                        onClick={() => handleDeleteDocument(file.fileName, index)}
                        style={{
                          cursor: "pointer",
                          width: "20px",
                          height: "20px",
                          opacity: 0.7,
                          transition: "opacity 0.2s ease"
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = "1"}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = "0.7"}
                      />
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
         
        
        <ButtonSecondary
          style={{
            width: "25%",
            background: !isEditable ? "#cccccc" : "#101e8e",
            color: "#fff",
            fontSize: `${General.accessibility.fontSize}rem`,
            marginTop: 24,
            cursor: !isEditable ? "not-allowed" : "pointer",
            opacity: !isEditable ? 0.6 : 1
          }}
          onClick={isEditable ? handleSubmit : undefined}
          disabled={!isEditable}
        > { submitloader? (
                  <Spinner width="30px" height="30px" />
                ) : General?.codeLabels["cm_update"]?.label !== undefined ? (
                  General?.codeLabels["cm_update"]?.label
                ) : (
                  "Update Request"
                )}
        </ButtonSecondary>
      </div>
      </TabContainer>
      {/* )} */}
    </div>
  );
};

export default UpdateModal;
